<sci-modal [title]="data.title | translate: data.params" size="sm" (dismissed)="ref.close(false)">
  <div class="confirm">
    <mat-icon class="confirm__icon" aria-hidden="true">{{ icon }}</mat-icon>
    <p class="confirm__message">{{ data.message | translate: data.params }}</p>
  </div>

  <sci-modal-footer>
    <button sci-button variant="link" color="neutral" (click)="ref.close(false)">
      {{ cancelText | translate }}
    </button>
    <button sci-button [color]="confirmColor" (click)="ref.close(true)">
      {{ confirmText | translate }}
    </button>
  </sci-modal-footer>
</sci-modal>
